import {Cureus} from '../Cureus';

Cureus.AdminArticleComments = {};

//= require_tree ./AdminArticleComments